import { FlyerLayoutAbstract } from './flyer-layout.abstract'
import moment from 'moment-timezone'

export default class Flyer_layout_center_swash_038LayoutModel extends FlyerLayoutAbstract {
  flourishes = [
    {
      name: 'scattered_line_large_white',
      left: 72,
      top: 276,
      width: 178,
      height: 5
    },
    {
      name: 'scattered_line_small_white',
      left: 124.5,
      top: 338,
      width: 73,
      height: 2
    }
  ]

  textLayouts = {
    event_name_1: {
      top: 166,
      left: 50,
      size: 42,
      width: 222,
      height: 98,
      align: 'center',
      lineHeight: 32
    },
    location_1: {
      top: 350,
      size: 15,
      left: 50,
      width: 222,
      height: 54,
      lineHeight: 18,
      align: 'center',
      widthAlign: 'center',
      whiteSpace: 'pre'
    }
  }

  dateLayouts = {
    date_1: {
      top: 293,
      daySize: 15,
      left: 50,
      width: 222,
      height: 38,
      lineHeight: 18,
      align: 'center'
    }
  }

  constructor(flyerDesign, eventData) {
    super(flyerDesign, eventData)
    this.init()
  }

  getLocationText1() {
    const formattedName = this.hobnobFormattedName?.() || ''
    const formattedAddressWithCity = this.hobnobFormattedAddressWithCity?.() || ''

    let location = null

    if (formattedName.length !== 0) {
      location = formattedName.toUpperCase()
      if (formattedAddressWithCity.length !== 0) {
        location = `${formattedName}\n${formattedAddressWithCity}`.toUpperCase()
      }
    } else if (formattedAddressWithCity.length !== 0) {
      location = formattedAddressWithCity.toUpperCase()
    }

    return location
  }

  getDateTexts() {
    const startDate = this.eventData.starts_at
    const endDate = this.eventData.ends_at
    const timeZone = this.eventData.timezone || 'UTC'

    const date1 = this.dateLayouts.date_1

    const safeDate1Color = this.dateProps.date1Props?.color?.replace('0x', '#') || '#cccccc'
    const safeDate1Font = this.dateProps.date1Props?.font?.replace(/\s+/g, '-') || 'Arial'

    let dates = []
    if (!startDate) return { type: 'date', dates }
    const start = moment.tz(startDate, timeZone)
    const isSingleDay = endDate && moment(startDate).isSame(endDate, 'day')

    let startDateStr = start.format('ddd, MMM D, h:mma').toUpperCase()
    let textParts = []

    if (endDate) {
      if (isSingleDay) {
        const endTimeStr = moment.tz(endDate, timeZone).format('h:mma').toUpperCase()
        textParts = [
          { text: startDateStr + ' ', font: safeDate1Font, color: safeDate1Color, size: date1.daySize },
          { text: 'till', font: 'Satisfy-Regular', color: safeDate1Color, size: 14 },
          { text: '\n' + endTimeStr, font: safeDate1Font, color: safeDate1Color, size: date1.daySize }
        ]
      } else {
        const endDateStr = moment.tz(endDate, timeZone).format('ddd, MMM D, h:mma').toUpperCase()
        textParts = [
          { text: startDateStr + ' ', font: safeDate1Font, color: safeDate1Color, size: date1.daySize },
          { text: 'till', font: 'Satisfy-Regular', color: safeDate1Color, size: 14 },
          { text: '\n' + endDateStr, font: safeDate1Font, color: safeDate1Color, size: date1.daySize }
        ]
      }
    } else {
      textParts = [
        { text: startDateStr, font: safeDate1Font, color: safeDate1Color, size: date1.daySize }
      ]
    }

    dates.push({
      textParts,
      align: date1.align,
      width: date1.width,
      height: date1.height,
      left: date1.left,
      right: date1.right,
      top: date1.top,
      color: safeDate1Color,
      font: safeDate1Font,
      size: date1.daySize,
      lineHeight: date1.lineHeight
    })

    return { type: 'date', dates }
  }
}
